import { render, staticRenderFns } from "./HomeKZRelationImg.vue?vue&type=template&id=2214f178"
import script from "./HomeKZRelationImg.vue?vue&type=script&lang=js"
export * from "./HomeKZRelationImg.vue?vue&type=script&lang=js"
import style0 from "./HomeKZRelationImg.vue?vue&type=style&index=0&id=2214f178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports